// import Verivox-App
import './bootstrap';

// import scripts
import mobileNavigation             from './scripts/mobileNavigation';
import checkboxes                   from './scripts/checkboxes';
import tooltip                      from './scripts/tooltip';
import openAria                     from './scripts/openAria';
import providerList                 from './scripts/providerList';
import magazineSlider               from './scripts/magazineSlider';
import ratgeberSlider               from './scripts/ratgeberSlider';
import serachCity                   from './scripts/searchCity';
import paolaLocationModal           from './scripts/paolaLocationModal';
import magazineCategoryFilter       from './scripts/magazineCategoryFilter';
import scrollTo                     from './scripts/scrollTo';
import pID                          from './scripts/pID';
import formOptionsToggle            from './scripts/formOptionsToggle';
import cookie                       from './scripts/cookie';
import defaultBanner                from './scripts/defaultBanner';

import compareTariffs               from './tarifrechner/compareTariffs';
import tariffCalculator             from './tarifrechner/tariffCalculator';
import resultTabs                   from './tarifrechner/resultTabs';
import verivoxRatings               from './tarifrechner/verivoxRatings';
import showTabs                     from './tarifrechner/showTabs';
import getGeolocation               from './tarifrechner/getGeolocation';
import rangeSlider                  from './tarifrechner/rangeSlider';
import showNextTariffs              from './tarifrechner/showNextTariffs';
import starRating                   from './tarifrechner/starRating';
import energyConsultant             from "./scripts/energyConsultant";

// Foundation
import { Foundation }    from 'foundation-sites/js/foundation.core';
import { MediaQuery }    from 'foundation-sites/js/foundation.util.mediaQuery';
import { Tabs }          from 'foundation-sites/js/foundation.tabs';
import { DropdownMenu }  from 'foundation-sites/js/foundation.dropdownMenu';
import { Accordion }     from 'foundation-sites/js/foundation.accordion';


Foundation.MediaQuery = MediaQuery;
Foundation.plugin(Tabs, 'tabs');
Foundation.plugin(DropdownMenu, 'dropdownMenu');
Foundation.plugin(Accordion, 'accordion');
Foundation.addToJquery($);


// run scripts
$(document).ready(() => {
    // needs to be before foundation() to make equalizer work
    magazineSlider();
    ratgeberSlider();

    $(document).foundation();

    // site
    mobileNavigation();
    scrollTo();
    magazineCategoryFilter();
    providerList();
    starRating();
    tooltip();
    serachCity();
    pID();
    paolaLocationModal();
    defaultBanner();

    //forms
    checkboxes();
    showNextTariffs();
    rangeSlider();

    // both forms
    getGeolocation();
    formOptionsToggle();

    tariffCalculator('gas');
    tariffCalculator('electricity');

    cookie(); // order matters: needs to be after tariffCalculator

    openAria();
    resultTabs();

    showTabs();
    compareTariffs();
    verivoxRatings();

    energyConsultant();

    //scrollTop($(window));
    //callout();
    //accordion();
    //checkboxes();
    //adviceSlider();
    //contentSlider();
    //verivoxNewsList();
});
